import { UI, SelectTypes as SelectComponentTypes, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

export declare namespace SelectTypes {
  type SelectionProps = string | null;

  type SelectionChange = (
    selections: SelectionProps,
    fieldName: string,
    filterIndex: number
  ) => void;

  interface Props {
    type: 'select';
    fieldName: string;
    filterIndex: number;
    title: string;
    options: SelectComponentTypes.Option[];
    onSelectionChange: SelectionChange;
    selection?: SelectionProps;
    customSelectProps?: Partial<
      Pick<
        SelectComponentTypes.Props,
        'placeholder' | 'maxOptionPerRender' | 'maxOptionsContentHeight' | 'disabled'
      >
    >;
  }
}

export const hasSelectSelection = (selection: SelectTypes.SelectionProps) => !!selection;

export const Select: React.FC<SelectTypes.Props> = ({
  title,
  options,
  fieldName,
  filterIndex,
  onSelectionChange,
  selection,
  customSelectProps = {},
}) => {
  const handleSelection = (value: string) => {
    onSelectionChange(value, fieldName, filterIndex);
  };

  if (!options.length) {
    return <></>;
  }

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} lineHeight="distant">
        {title}
      </Text>
      <Stack bgColor={Color.background} borderRadius={BoxBorder.thick}>
        <UI.Select
          testID="select-filter-options"
          options={options as SelectComponentTypes.Option[]}
          placeholder="Selecione uma opção"
          onValueChange={handleSelection}
          selectedValue={selection || undefined}
          {...customSelectProps}
        />
      </Stack>
    </VStack>
  );
};
